@import "~/styles/v1/_variables.scss";
@import "~/styles/v1/_spacing.scss";

$helperWidth: 130;
$helperSpacer: 10;

.FlyoverHelper {
  background: $system_eggplant-base;
  border-radius: 6px;
  color: $system_white-lightest;
  margin-right: $helperSpacer + px;
  overflow-wrap: break-word;
  padding: $size-S;
  width: $helperWidth + px;
  z-index: 102;

  a {
    color: $system_eggplant-lightest;
    text-decoration: underline;

    &:focus,
    &:hover {
      color: $system_white-lightest;
    }
  }
}
